import React, { forwardRef } from 'react';
import './Input.css';

const USDateInput = forwardRef(({ 
  id, 
  value, 
  onChange, 
  required = false, 
  disabled = false, 
  min, 
  className = '',
  label,
  error,
  ...props 
}, ref) => {
  // Convert ISO string to YYYY-MM-DD format for HTML5 date input
  const formatValueForInput = (isoString) => {
    if (!isoString) return '';
    
    const date = new Date(isoString + 'T00:00:00');
    if (isNaN(date.getTime())) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (!inputValue) {
      onChange(e);
      return;
    }

    // Convert to ISO string for consistent handling
    const date = new Date(inputValue + 'T00:00:00');
    if (!isNaN(date.getTime())) {
      const event = {
        ...e,
        target: {
          ...e.target,
          value: date.toISOString().split('T')[0] // Return YYYY-MM-DD format
        }
      };
      onChange(event);
    } else {
      onChange(e);
    }
  };

  const inputClass = `input-field ${error ? 'input-error' : ''} ${className}`.trim();

  return (
    <div className="input-container">
      {label && <label htmlFor={id} className="input-label">{label}</label>}
      <input
        ref={ref}
        id={id}
        type="date"
        className={inputClass}
        value={formatValueForInput(value)}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        min={min ? formatValueForInput(min) : undefined}
        lang="en-US"
        data-format="mm-dd-yyyy"
        style={{
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
          direction: 'ltr'
        }}
        {...props}
      />
      {error && <div className="input-error-message">{error}</div>}
    </div>
  );
});

export default USDateInput;